import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Separator } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';

const ReservationTicketNumberView = observer((): React.JSX.Element => {
  const {
    reservationStore: { reservation },
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  return (
    <>
      <p className="h4">{translate('reservation.store.administration.ticket.hello')}</p>
      <Separator spacing="xsmall" color="invisible" />
      <p>{translate('reservation.store.administration.ticket.queueNumber')}</p>
      <p className="h1">{reservation.ticketNumber}</p>
      <Separator spacing="small" color="invisible" />
      <p>{translate('reservation.store.administration.ticket.footer')}</p>
    </>
  );
});

export default ReservationTicketNumberView;
